import React from 'react';
import { CoreContext } from './core-context';
export const withCoreContext = (Component) => (props) => {
    return React.createElement(CoreContext.Consumer, null, (context) => React.createElement(Component, Object.assign({}, props, { context: context })));
};
